import { render, staticRenderFns } from "./SelectStageFreight.vue?vue&type=template&id=12db8f2c&scoped=true&"
import script from "./SelectStageFreight.vue?vue&type=script&lang=ts&"
export * from "./SelectStageFreight.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12db8f2c",
  null
  
)

export default component.exports